import api from '@pray/shared/utils/api';

export type CatalogLinkScreen =
  | 'artist'
  | 'content'
  | 'content-series'
  | 'daily'
  | 'giving-paywall'
  | 'upgrade-paywall';

type Props = {
  artistId: string;
  catalogId: string;
  screen: CatalogLinkScreen;
  id: string;
};

export async function postCreateCatalogLink({ artistId, catalogId, screen, id }: Props) {
  if (!artistId) throw new Error('Artist ID is required');
  if (!catalogId) throw new Error('Catalog ID is required');

  const response = await api.executePostRequest<{ data: { url: string } }>(
    `/web/studio/artists/${artistId}/catalogs/${catalogId}/links`,
    { screen, id }
  );

  return response.data.data;
}
